import { useApi } from '@/api';
import {
  CurrencyTooltipChange,
  EntityName,
  KpiSkeleton,
  MultipleKpiCard
} from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, useIsMobile } from '@blockanalitica/ui';
import StarFarmsKpis from './StarFarmsKpis';

export default function FarmKpiTab({ daysAgo }: { daysAgo: string }) {
  const estimatedAbbrev = useIsMobile() ? 'Est.' : 'Estimated';
  const [data, error] = useApi({
    url: `/farms/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  const isMobile = useIsMobile();

  if (error) {
    throw error;
  }

  if (data) {
    const sky = data['sky_farm'];
    const chronicle = data['chronicle_farm'] ? data['chronicle_farm'] : null;

    const skyFooter = [
      {
        title: 'Total Staked',
        value: (
          <CurrencyTooltipChange
            field="total_staked"
            data={sky}
            options={{
              currency: tokensMapping('USDS'),
              iconSize: '0'
            }}
          />
        )
      },

      {
        title: `Total ${estimatedAbbrev} ${sky.rewards_token_symbol} Rewards`,
        value: (
          <CurrencyTooltipChange
            field="total_farmed"
            data={sky}
            options={{
              currency: {
                name: sky.rewards_token_symbol,
                address: sky.rewards_token_address
              },
              iconSize: '0'
            }}
          />
        )
      }
    ];

    if (!isMobile) {
      skyFooter.push({
        title: 'Suppliers',
        value: <CurrencyTooltipChange field="depositors" data={sky} />
      });
    }

    const chronFooter = [
      {
        title: 'Total Staked',
        value: (
          <CurrencyTooltipChange
            field="total_staked"
            data={chronicle}
            options={{
              currency: tokensMapping('USDS'),
              iconSize: '0'
            }}
          />
        )
      },
      {
        title: `Total ${estimatedAbbrev} Points`,
        value: <CurrencyTooltipChange field="total_farmed" data={chronicle} />
      }
    ];

    if (!isMobile) {
      chronFooter.push({
        title: 'Suppliers',
        value: <CurrencyTooltipChange field="depositors" data={chronicle} />
      });
    }

    return (
      <>
        {/* Sky Farm - First */}

        {/* Star Farms - Second */}
        <StarFarmsKpis daysAgo={daysAgo} />

        {/* Chronicle Farm - Third */}
        {chronicle && (
          <MultipleKpiCard
            linkTo={chronicle.address}
            title={
              <Flex justifyContent="space-between" flex="1">
                <Flex gap="s" alignItems="flex-end">
                  <EntityName
                    symbol1={
                      <CryptoIcon
                        name={tokensMapping('USDS').name}
                        address={tokensMapping('USDS').address}
                        size="2"
                      />
                    }
                    symbol2={
                      <CryptoIcon
                        name={tokensMapping('CHRON').name}
                        address={tokensMapping('CHRON').address}
                        size="2"
                      />
                    }
                    fontSize="1"
                    color="text">
                    Supply {tokensMapping('USDS').name} to get Chronicle points
                  </EntityName>
                </Flex>
              </Flex>
            }
            footer={chronFooter}
          />
        )}
      </>
    );
  }

  return <KpiSkeleton />;
}
